import { render } from "./PosPurchase.vue?vue&type=template&id=6267b8d2&scoped=true&ts=true"
import script from "./PosPurchase.vue?vue&type=script&lang=ts"
export * from "./PosPurchase.vue?vue&type=script&lang=ts"

import "./PosPurchase.vue?vue&type=style&index=0&id=6267b8d2&scoped=true&lang=css"

import exportComponent from "/var/www/html/myittar_pharmacy_pos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6267b8d2"]])

export default __exports__